<script>
import Checkbox from '@/components/Checkbox'
import LocalStorageUtils from '@/utils/localStorageUtils'
import LogUtils from '@/utils/logUtils'
import ConfigUtils from '@/utils/configUtils'
import Config from '~/config'
import Package from '~/package.json'

export default
{
    name: 'devtools',

    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div id='devtools'>
                <h1 class='section-title'>Build</h1>
                <span class='code'>v{Package.version} '{Package.release}' build {__BUILD_NUMBER__}</span>
                <h1 class='section-title'>Build Date</h1>
                <span class='code'>{ new Date(__BUILD_DATE__).toString() } </span>
                <h1 class='section-title'>process.env</h1>
                <tree-view data={process.env} options={{maxDepth: 1, modifiable: true}} />
                <br />
                <h1 class='section-title'>this.$store.state</h1>
                <tree-view data={this.$store.state} options={{maxDepth: 1, modifiable: true}} on-change-data={this.onStateDataChanged} />
                <br />
                <h1 class='section-title'>config</h1>
                <tree-view data={Config} options={{maxDepth: 1, modifiable: true}} on-change-data={this.onConfigDataChanged} />
                <br />
                <h1 class='section-title' on-click={() => this.showLogs = !this.showLogs}>logs</h1>
                <div class='logs' v-show={this.showLogs}>
                {
                    LogUtils.LOGS.map(log =>
                    {
                        return <div class={`log ${log.type}`}>{ log.message }</div>
                    })
                }
                </div>
                <br />
                <Checkbox label='Use local API' v-model={LocalStorageUtils.useLocalApi} />
                <Checkbox label='Use local CDN' v-model={LocalStorageUtils.useLocalCdn} />
                <Checkbox label='Use intensive animations' v-model={LocalStorageUtils.useIntensiveAnimations} />
                <Checkbox label='Send notifications to Test segment' v-model={LocalStorageUtils.sendPushNotifsToTest} />
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
            showLogs: false
        }
    },

    watch:
    {
    },

    computed:
    {
    },

    methods:
    {
        onStateDataChanged (data)
        {
            this.$store.replaceState(data)

            this.showDataChangedSuccessfulMessage()
        },

        onConfigDataChanged (data)
        {
            ConfigUtils.overwriteConfig(data);
            LocalStorageUtils.configOverwrite = data;

            this.showDataChangedSuccessfulMessage()
        },

        showDataChangedSuccessfulMessage ()
        {
            this.$toast.success('You dirty!')
        }
    },

    components:
    {
        Checkbox
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#devtools
{
    padding: 4vh 0;

    .OnDesktop({ padding: 4vh 2vh; });

    .tree-view-item-value.tree-view-item-value-string
    {
        width: 100%;
    }

    .section-title
    {
        font-size: 5vw;

        .OnDesktop({ font-size: 1.3vw; });
    }

    .code
    {
        background: var(--theme-accent-color-90-percent);
        line-height: 1.8;
        border-radius: 4px;
        padding: 4px 8px;
    }

    .checkbox
    {
        margin-top: 2vh;
    }

    .logs
    {
        .log
        {
            word-break: break-word;
            margin-top: 10px;
            padding-top: 10px;
            border-top: 1px solid var(--theme-border-color);

            &:first-of-type
            {
                border-top: none;
            }

            &.error
            {
                color: red;
            }

            &.warn
            {
                color: orange;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Devtools.vue